export default {"src":"/_next/static/media/scanning.068fd24e.svg","height":50,"width":64};